import React from 'react';

import { Button, CompletionButton, Icon, Stack, TaskTile, Text } from 'shell/components';
import { getUserPreferredFullName } from 'utils/helper';

const AssociatedTasksSection = ({ tasks, getUserByAccountId, onClickTask, onClickCreate, updateTaskStatus }) => {
    const toggleComplete = (e, id, status) => {
        e && e.stopPropagation();
        if (status !== 'completed') {
            updateTaskStatus(id, 'completed');
        } else {
            updateTaskStatus(id, 'toDo');
        }
    };

    return (
        <Stack spacing={1}>
            <Text variant={'p2'} weight={'semibold'}>
                Tasks Associated ({tasks.length})
            </Text>
            {tasks.map((task) => (
                <TaskTile
                    data-cy={task.title}
                    key={task.id}
                    endComponent={
                        <CompletionButton
                            checked={task.status === 'completed'}
                            onClick={(e) => toggleComplete(e, task.id, task.status)}
                        />
                    }
                    getNameById={(id) => getUserPreferredFullName(getUserByAccountId(id))}
                    task={task}
                    onClick={() => onClickTask(task.id)}
                />
            ))}
            <Button
                sx={{ alignSelf: 'flex-start' }}
                startIcon={<Icon kind={'add'} />}
                variant={'tertiary'}
                onClick={onClickCreate}
            >
                Create Associated Task
            </Button>
        </Stack>
    );
};

export default AssociatedTasksSection;
